import React, { FC, useMemo } from 'react';
import { useT, UT } from '@transifex/react';
import { IntlShape } from 'react-intl';
import { Button } from '@raisin/components-lib';
import { useAuthContext } from '@raisin/cp-layout';
import { PLATFORMS_LOGO_URLS } from '@raisin/cp-utils';
import { DBSProduct } from 'types';
import useOfferOrderLink from 'hooks/useOfferOrderLink';
import productPageMessages from '../../messages';
import { BankAffiliateCTABanner } from 'components/Banks/BankDetails/BankAffiliateProduct/BankAffiliateCTABanner';

interface ProductPageCTABannerProps {
  selectedOffer: DBSProduct;
  intl: IntlShape;
}

export const ProductPageCTABanner: FC<ProductPageCTABannerProps> = ({ selectedOffer, intl }) => {
  const t = useT();
  const { isLoggedIn } = useAuthContext();

  const orderLink = useOfferOrderLink(intl.locale, selectedOffer, isLoggedIn);
  const platformLogo = useMemo(
    () =>
      isLoggedIn
        ? PLATFORMS_LOGO_URLS.PRIVATE[intl.locale]
        : PLATFORMS_LOGO_URLS.PUBLIC[intl.locale],
    [intl.locale, isLoggedIn],
  );
  return (
    <BankAffiliateCTABanner
      imageSrc={platformLogo}
      content={<UT _str={productPageMessages.affiliateCTABannerText} />}
      cta={
        <Button
          size="medium"
          href={orderLink}
          sx={(theme) => ({
            width: theme.breakpoints.down('lg') ? '100%' : 'max-content',
          })}
          data-testid="cta-banner-button"
        >
          {t(productPageMessages.affiliateCTAButtonText)}
        </Button>
      }
    />
  );
};

export default ProductPageCTABanner;
